<template>
  <Row class="repay_bar_box">
    <NavBar
      class="nav_bar_box"
      title=""
    />
    <div class="laisda" :style="{ 'padding':' 0 30px'}">
      <p :style="{ 'color': '#fff','font-size': '16px',}" v-html="text_body" />
    </div>
  </Row>
</template>
<script type="text/jsx">
import Pdfh5 from 'pdfh5'
import axios from 'axios'
import 'pdfh5/css/pdfh5.css'
import { fetchList, getaxios, getaxiosdata, deleteaxios, PostData, PostPut, updateArticle } from '@/api/article'
import { Toast, NavBar, Col, Cell, CellGroup, Row, TabbarItem, Divider, Tabbar, Image as VanImage, Uploader, Button } from 'vant'
import HeadNavBar from '@/components/HeadNavBar'

export default {
  name: 'App',
  components: {
    HeadNavBar,
    Tabbar,
    Toast,
    NavBar,
    Col,
    Row,
    Divider,
    VanImage,
    TabbarItem,
    Uploader,
    Button,
    Cell, CellGroup
  },
  data() {
    return {
      banner_title: '',
      caseInfoId: '',
      repay_data: '',
      code: '',
      text_body: '【安徽中钧】尹治业,你于2020年09月30日向富邦华一银行有限公司借款600.00元，因你未按约履行还款义务。北京中保国信融资保有限公司（简称中保国信公司）根据你的委托已于2020年12月27日向富邦华一银行承担了担保责任，依法取得对你的担保追偿权。现中保国信公司已将对你的上述担保追偿权转让至我司，《债权转让协议》详见链接（https://pla.cdjkyl.com/#/fBovY)。现根据中保国信公司委托特就担保追偿权转让事宜予以通知。债权转让通知授权书详见链接（https://pla.cdjkyl.com/#/eY5Ph）。请你收到本通知后立即向我司履行还款义务，联系电话：0556-8857666，联系人：安徽中钧企业管理有限公司。'
    }
  },
  mounted() {

  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:#3a3e4f')

    this.banner_title = this.$store.state.user.web_name
    this.code = this.$route.fullPath.slice(this.$route.fullPath.indexOf('?') + 1, this.$route.fullPath.length)
    // 获取连接
    this.getDirectLink()
  },
  methods: {
    // 获取连接
    async getDirectLink() {
      const url = {
        url: `/plaintiff/api/home/direct/${this.code}`,
        type: true
      }
      await getaxiosdata(url).then(response => {
        if (response.code == 200) {
          this.caseInfoId = this.$common.UrlToJson('caseInfoId', response.data.url)
          this.GetRepay()
        } else {
          Toast.fail('获取详情用户id失败，请勿修改网页链接参数')
          this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
        }
      })
    },
    async GetRepay() {
      const url = {
        url: `/mediate/api/smsPage/showDebt/${this.caseInfoId}`,
        type: true
      }
      await getaxiosdata(url).then(response => {
        if (response.code === '200') {
          this.repay_data = response.data
          this.text_body = response.data.content

          const http1 = this.text_body.substring(this.text_body.indexOf('https://'), this.text_body.indexOf(')'))
          const http2 = this.text_body.substring(this.text_body.lastIndexOf('https://'), this.text_body.lastIndexOf('）'))
          this.text_body = this.text_body.replace(http1, `<a style='color: #fff'  href="${http1}">${http1}</a>`).replace(http2, `<a style='color: #fff' href="${http2}">${http2}</a>`)
        } else {
          Toast.fail(`获取${this.code_data.text}详情失败`)
          this.is_id_text = `获取${this.code_data.text}详情失败`
        }
      })
    }

  }
}
</script>

<style lang="less" >

    .repay_bar_box{
        .wx_code_img_box{
            position: relative;
            .wx_code{
                text-align: center;
                .wx_code_text{
                    color: #fff;
                    font-size: 16px;
                    line-height: 1.5;
                    padding: 10px 0;

                }
                .wx_code_img{
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%,0);
                }
            }

        }
        .nav_bar_box{
            margin-bottom: 40px;
            background-color: #3a3e4f;
            .van-nav-bar__title{
                color: #fff;

            }
        }
        .repay_title_box{
            margin: 0 auto;
            width: 350px;
            background-color: #fff;
            .repay_money_box{
                padding-bottom: 20px;
                text-align: center;
                .repay_money{
                    color: #999999FF;
                    font-size: 18px;
                    padding: 30px 0 16px;
                }
            }
            .repay_title_time{
                text-align: center;
                height: 60px;
                line-height: 60px;
                font-size: 16px;
                color: #333333FF;
            }

        }

    }

</style>
